import { UpdateBeneficiaryRequestType, UpdateEmployeeRequestType, VerifyPayeeRequestType } from 'PublicEntityTypes';
import useSWRMutation from 'swr/mutation';
import { BENEFICIARY_API_PATH, EMPLOYEE_API_PATH } from '../contexts/data-context/data-provider';
import { BeneficiaryView, EmployeeView, PayeeCheckView } from '../types/entity-types';
import { patchSwrFetcherWithDynamicUrl } from '../utils/patch-swr-fetcher-with-dynamic-url';
import { postSwrFetcher } from '../utils/post-swr-fetcher';
import { putSwrFetcherWithDynamicUrl } from '../utils/put-swr-fetcher-with-dynamic-url';

const VERIFY_PAYEE_API_PATH = '/api/verify-payee';

export const usePayeeCheck = () => {
  const { trigger: triggerVerifyPayee, isMutating: isVerifyingPayee } = useSWRMutation<
    PayeeCheckView,
    Error,
    string,
    VerifyPayeeRequestType
  >(VERIFY_PAYEE_API_PATH, postSwrFetcher);
  const { trigger: triggerUpdateBeneficiary } = useSWRMutation<
    BeneficiaryView,
    Error,
    string,
    { urlSuffix: string } & UpdateBeneficiaryRequestType
  >(BENEFICIARY_API_PATH, patchSwrFetcherWithDynamicUrl);
  const { trigger: triggerUpdateEmployee } = useSWRMutation<
    EmployeeView,
    Error,
    string,
    { urlSuffix: string } & UpdateEmployeeRequestType
  >(EMPLOYEE_API_PATH, putSwrFetcherWithDynamicUrl);

  return {
    isMutating: {
      isVerifyingPayee,
    },
    mutations: {
      triggerVerifyPayee,
      triggerUpdateBeneficiary,
      triggerUpdateEmployee,
    },
  };
};
